import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { api } from "../../lib/api";
import { setAuth } from "../../store/authSlice";

export default function Login() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  // const [email, setEmail] = useState("admin@navigatio.guru");
  // const [password, setPassword] = useState("Navigatio@123");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { email, password });
      const data = res.data?.data;
      const token = data?.token;
      if (!token) throw new Error("Token missing");
      dispatch(setAuth({
        token,
        user: data?.user ?? null,
        permissions: data?.permissions ?? [],
      }));
      nav("/", { replace: true });
    } catch (e) {
      setErr(e?.response?.data?.message || e.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white grid place-items-center p-4">
      <div className="w-full max-w-md border rounded-2xl p-6">
        <h1 className="text-2xl font-bold">Admin Login</h1>
        <p className="text-sm text-gray-600 mt-1">Sign in to continue.</p>

        <form onSubmit={onSubmit} className="space-y-4 mt-6">
          <div>
            <label className="text-sm font-semibold">Email</label>
            <input
              className="mt-2 w-full border rounded-xl px-3 py-2 outline-none focus:ring-2 focus:ring-black"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div>
            <div className="flex items-center justify-between">
              <label className="text-sm font-semibold">Password</label>
              
            </div>
            <div className="relative mt-2">
              <input
                type={showPassword ? "text" : "password"}
                className="w-full border rounded-xl px-3 py-2 pr-10 outline-none focus:ring-2 focus:ring-black"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-black"
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
            <Link
                to="/forgot-password"
                className="text-xs text-gray-500 hover:text-black transition-colors"
              >
                Forgot password?
              </Link>
          </div>

          {err && <div className="text-sm text-red-600">{err}</div>}

          <button
            disabled={loading}
            className="w-full bg-black text-white rounded-xl py-2 font-semibold hover:opacity-90 disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}